import AnalysisHeaderDesktop from "./analysis/analysis-header-desktop"
import AnalysisHeaderMobile from "./analysis/analysis-header-mobile"
import CubiqHeaderDesktop from "./cubiq-header-desktop"
import CubiqHeaderMobile from "./cubiq-header-mobile"
import OverviewHeaderDesktop from "./overview/overview-header-desktop"
import StatsHeaderDesktop from "./stats/stats-header-desktop"
import StatsHeaderMobile from "./stats/stats-header-mobile"
import UnitsHeaderMobile from "./units/units-header-mobile"
import UnitsHeaderDesktop from "./units/units-header-desktop"
import OverviewHeaderMobile from "./overview/overview-header-mobile"
import MonitoringHeaderDesktop from "./monitoring/monitoring-header-desktop"
import StandardHeaderDesktop from "./standard-header-desktop"
import StandardHeaderMobile from "./standard-header-mobile"

const Header = {
  overview: { mobile: OverviewHeaderMobile, desktop: OverviewHeaderDesktop },
  monitoring: { mobile: MonitoringHeaderDesktop, desktop: MonitoringHeaderDesktop },
  stats: { mobile: StatsHeaderMobile, desktop: StatsHeaderDesktop },
  analysis: { mobile: AnalysisHeaderMobile, desktop: AnalysisHeaderDesktop },
  units: { mobile: UnitsHeaderMobile, desktop: UnitsHeaderDesktop },
  cubiq: { mobile: CubiqHeaderMobile, desktop: CubiqHeaderDesktop },
  default: { mobile: StandardHeaderMobile, desktop: StandardHeaderDesktop }
}

export default Header
